export const DATE_FORMATS = [
    'MM/dd/yyyy',
    'dd/MM/yyyy',
    'yyyy-MM-dd',
    'MMM dd, yyyy',
    'dd MMM yyyy',
    'MMMM dd, yyyy',
    'dd MMMM yyyy',
    'MM-dd-yyyy',
    'dd-MM-yyyy',
    'yyyy/MM/dd',
    'MM.dd.yyyy',
    'dd.MM.yyyy',
    'yyyyMMdd',
];

export const TIME_ZONES = [
    'Alaskan Standard Time',
    'Central Standard Time',
    'Eastern Standard Time',
    'Hawaiian Standard Time',
    'Mountain Standard Time',
    'Pacific Standard Time',

    // 'Atlantic Standard Time',
    // 'Newfoundland Standard Time',
    // 'E. South America Standard Time',
    // 'GMT Standard Time',
    // 'W. Europe Standard Time',
    // 'Romance Standard Time',
    // 'Russian Standard Time',
    // 'Arabian Standard Time',
    // 'India Standard Time',
    // 'China Standard Time',
    // 'Tokyo Standard Time',
    // 'AUS Eastern Standard Time',
    // 'New Zealand Standard Time',
    // 'Central Europe Standard Time',
    // 'UTC',
    // 'Dateline Standard Time',
    // 'UTC-11',
];

export const CURRENCY_CODES = [
    'USD',
    'EUR',
    'GBP',
    'JPY',
    'AUD',
    'CAD',
    'CHF',
    'CNY',
    'HKD',
    'NZD',
    'SEK',
    'KRW',
    'SGD',
    'NOK',
    'MXN',
    'INR',
    'RUB',
    'ZAR',
    'TRY',
    'BRL',
    'TWD',
    'DKK',
    'PLN',
    'THB',
    'IDR',
    'HUF',
    'CZK',
    'ILS',
    'CLP',
    'PHP',
    'AED',
    'COP',
    'SAR',
    'MYR',
    'RON',
    'ARS',
    'BGN',
    'HRK',
    'ISK',
    'KZT',
    'LKR',
    'MAD',
    'NGN',
    'PKR',
    'QAR',
    'VND',
    'EGP',
    'KES',
    'UAH',
    'JOD',
    'OMR',
    'BHD',
];

export const PHONE_NUMBER_PREFIXES = [
    { label: 'United States / Canada', value: '+1' },
    { label: 'Russia', value: '+7' },
    { label: 'Egypt', value: '+20' },
    { label: 'South Africa', value: '+27' },
    { label: 'Greece', value: '+30' },
    { label: 'Netherlands', value: '+31' },
    { label: 'Belgium', value: '+32' },
    { label: 'France', value: '+33' },
    { label: 'Spain', value: '+34' },
    { label: 'Hungary', value: '+36' },
    { label: 'Italy', value: '+39' },
    { label: 'Romania', value: '+40' },
    { label: 'Switzerland', value: '+41' },
    { label: 'Austria', value: '+43' },
    { label: 'United Kingdom', value: '+44' },
    { label: 'Denmark', value: '+45' },
    { label: 'Sweden', value: '+46' },
    { label: 'Norway', value: '+47' },
    { label: 'Poland', value: '+48' },
    { label: 'Germany', value: '+49' },
    { label: 'Peru', value: '+51' },
    { label: 'Mexico', value: '+52' },
    { label: 'Cuba', value: '+53' },
    { label: 'Argentina', value: '+54' },
    { label: 'Brazil', value: '+55' },
    { label: 'Chile', value: '+56' },
    { label: 'Colombia', value: '+57' },
    { label: 'Venezuela', value: '+58' },
    { label: 'Malaysia', value: '+60' },
    { label: 'Australia', value: '+61' },
    { label: 'Indonesia', value: '+62' },
    { label: 'Philippines', value: '+63' },
    { label: 'New Zealand', value: '+64' },
    { label: 'Singapore', value: '+65' },
    { label: 'Thailand', value: '+66' },
    { label: 'Japan', value: '+81' },
    { label: 'South Korea', value: '+82' },
    { label: 'Vietnam', value: '+84' },
    { label: 'China', value: '+86' },
    { label: 'Turkey', value: '+90' },
    { label: 'India', value: '+91' },
    { label: 'Pakistan', value: '+92' },
    { label: 'Afghanistan', value: '+93' },
    { label: 'Sri Lanka', value: '+94' },
    { label: 'Myanmar', value: '+95' },
    { label: 'Iran', value: '+98' },
    { label: 'Morocco', value: '+212' },
    { label: 'Algeria', value: '+213' },
    { label: 'Tunisia', value: '+216' },
    { label: 'Libya', value: '+218' },
    { label: 'Gambia', value: '+220' },
    { label: 'Senegal', value: '+221' },
    { label: 'Mauritania', value: '+222' },
    { label: 'Mali', value: '+223' },
    { label: 'Guinea', value: '+224' },
    { label: 'Ivory Coast', value: '+225' },
    { label: 'Burkina Faso', value: '+226' },
    { label: 'Niger', value: '+227' },
    { label: 'Togo', value: '+228' },
    { label: 'Benin', value: '+229' },
    { label: 'Mauritius', value: '+230' },
    { label: 'Liberia', value: '+231' },
    { label: 'Sierra Leone', value: '+232' },
    { label: 'Ghana', value: '+233' },
    { label: 'Nigeria', value: '+234' },
    { label: 'Chad', value: '+235' },
    { label: 'Central African Republic', value: '+236' },
    { label: 'Cameroon', value: '+237' },
    { label: 'Cape Verde', value: '+238' },
    { label: 'Sao Tome and Principe', value: '+239' },
    { label: 'Gabon', value: '+241' },
    { label: 'Congo', value: '+242' },
    { label: 'Democratic Republic of the Congo', value: '+243' },
    { label: 'Angola', value: '+244' },
    { label: 'Guinea-Bissau', value: '+245' },
    { label: 'Seychelles', value: '+248' },
    { label: 'Sudan', value: '+249' },
    { label: 'Rwanda', value: '+250' },
    { label: 'Ethiopia', value: '+251' },
    { label: 'Somalia', value: '+252' },
    { label: 'Djibouti', value: '+253' },
    { label: 'Kenya', value: '+254' },
    { label: 'Tanzania', value: '+255' },
    { label: 'Uganda', value: '+256' },
    { label: 'Burundi', value: '+257' },
    { label: 'Mozambique', value: '+258' },
    { label: 'Zambia', value: '+260' },
    { label: 'Madagascar', value: '+261' },
    { label: 'Zimbabwe', value: '+263' },
    { label: 'Namibia', value: '+264' },
    { label: 'Malawi', value: '+265' },
    { label: 'Lesotho', value: '+266' },
    { label: 'Botswana', value: '+267' },
    { label: 'Eswatini', value: '+268' },
    { label: 'Comoros', value: '+269' },
    { label: 'Greenland', value: '+299' },
    { label: 'Portugal', value: '+351' },
    { label: 'Luxembourg', value: '+352' },
    { label: 'Ireland', value: '+353' },
    { label: 'Iceland', value: '+354' },
    { label: 'Albania', value: '+355' },
    { label: 'Malta', value: '+356' },
    { label: 'Cyprus', value: '+357' },
    { label: 'Finland', value: '+358' },
    { label: 'Bulgaria', value: '+359' },
    { label: 'Lithuania', value: '+370' },
    { label: 'Latvia', value: '+371' },
    { label: 'Estonia', value: '+372' },
    { label: 'Moldova', value: '+373' },
    { label: 'Armenia', value: '+374' },
    { label: 'Belarus', value: '+375' },
    { label: 'Andorra', value: '+376' },
    { label: 'Monaco', value: '+377' },
    { label: 'Ukraine', value: '+380' },
    { label: 'Serbia', value: '+381' },
    { label: 'Montenegro', value: '+382' },
    { label: 'Kosovo', value: '+383' },
    { label: 'Croatia', value: '+385' },
    { label: 'Slovenia', value: '+386' },
    { label: 'Bosnia and Herzegovina', value: '+387' },
    { label: 'North Macedonia', value: '+389' },
    { label: 'Czech Republic', value: '+420' },
    { label: 'Slovakia', value: '+421' },
    { label: 'Liechtenstein', value: '+423' },
    { label: 'Belize', value: '+501' },
    { label: 'Guatemala', value: '+502' },
    { label: 'El Salvador', value: '+503' },
    { label: 'Honduras', value: '+504' },
    { label: 'Nicaragua', value: '+505' },
    { label: 'Costa Rica', value: '+506' },
    { label: 'Panama', value: '+507' },
    { label: 'Haiti', value: '+509' },
    { label: 'Bolivia', value: '+591' },
    { label: 'Guyana', value: '+592' },
    { label: 'Ecuador', value: '+593' },
    { label: 'Paraguay', value: '+595' },
    { label: 'Suriname', value: '+597' },
    { label: 'Uruguay', value: '+598' },
    { label: 'Brunei', value: '+673' },
    { label: 'Papua New Guinea', value: '+675' },
    { label: 'Fiji', value: '+679' },
    { label: 'Hong Kong', value: '+852' },
    { label: 'Macau', value: '+853' },
    { label: 'Cambodia', value: '+855' },
    { label: 'Laos', value: '+856' },
    { label: 'Bangladesh', value: '+880' },
    { label: 'Taiwan', value: '+886' },
    { label: 'Maldives', value: '+960' },
    { label: 'Lebanon', value: '+961' },
    { label: 'Jordan', value: '+962' },
    { label: 'Syria', value: '+963' },
    { label: 'Iraq', value: '+964' },
    { label: 'Kuwait', value: '+965' },
    { label: 'Saudi Arabia', value: '+966' },
    { label: 'Yemen', value: '+967' },
    { label: 'Oman', value: '+968' },
    { label: 'United Arab Emirates', value: '+971' },
    { label: 'Israel', value: '+972' },
    { label: 'Bahrain', value: '+973' },
    { label: 'Qatar', value: '+974' },
    { label: 'Bhutan', value: '+975' },
    { label: 'Mongolia', value: '+976' },
    { label: 'Nepal', value: '+977' },
];
